import {observer} from "mobx-react";
import {FieldInput} from "@kroschke/react-ui";
import {FieldSelect} from "../../ui";
import {countryStore} from "../../../store";

interface FmsModalDialogReceiverProps {
    help: FmsReceiverFormHelp
    data: FmsReceiverFormData
    disabled: boolean
    onBlur: () => any
    onChange: (value: FmsReceiverFormData) => any
}

export interface FmsReceiverFormData {
    packageId: string
    version: number
    city: string
    addition: string
    country: string
    houseNumber: string
    postCode: string
    street: string
    line1: string
    line2: string
    mail: string
    phone: string
}

export interface FmsReceiverFormHelp {
    city?: string | undefined
    addition?: string | undefined
    country?: string | undefined
    houseNumber?: string | undefined
    postCode?: string | undefined
    street?: string | undefined
    line1?: string | undefined
    line2?: string | undefined
    mail?: string | undefined
    phone?: string | undefined
}


const FmsReceiverForm = observer(function FmsReceiverForm({
                                                              data,
                                                              help,
                                                              disabled,
                                                              onBlur,
                                                              onChange
                                                          }: FmsModalDialogReceiverProps) {
    return <>
        <div style={{
            display: 'flex'
        }}>
            <div style={{
                flex: '1'
            }}>
                <div className={"columns"}>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={true}
                            help={help.line1}
                            invalid={Boolean(help.line1)}
                            value={data.line1}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                line1: val
                            })}
                            label={"Adresszeile 1"}
                        />
                    </div>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={false}
                            help={help.line2}
                            invalid={Boolean(help.line2)}
                            value={data.line2}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                line2: val
                            })}
                            label={"Adresszeile 2"}
                        />
                    </div>
                    <div className={'column is-one-third'}></div>
                </div>
                <div className={"columns"}>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={true}
                            help={help.street}
                            invalid={Boolean(help.street)}
                            value={data.street}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                street: val
                            })}
                            label={"Straße"}
                        />
                    </div>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={false}
                            help={help.houseNumber}
                            invalid={Boolean(help.houseNumber)}
                            value={data.houseNumber}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                houseNumber: val
                            })}
                            label={"Hausnummer"}
                        />
                    </div>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={false}
                            help={help.addition}
                            invalid={Boolean(help.addition)}
                            value={data.addition}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                addition: val
                            })}
                            label={"Adresszusatz"}
                        />
                    </div>
                </div>

                <div className={"columns"}>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={true}
                            help={help.postCode}
                            invalid={Boolean(help.postCode)}
                            value={data.postCode}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                postCode: val
                            })}
                            label={"PLZ"}
                        />
                    </div>
                    <div className={'column is-one-third'}>
                        <FieldInput
                            disabled={disabled}
                            required={true}
                            help={help.city}
                            invalid={Boolean(help.city)}
                            value={data.city}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                city: val
                            })}
                            label={"Ort"}
                        />
                    </div>
                    <div className={'column is-one-third'}>
                        <FieldSelect
                            disabled={disabled}
                            label={"Land"}
                            invalid={Boolean(help.country)}
                            help={help.country}
                            options={countryStore.options}
                            value={data.country}
                            onBlur={() => onBlur()}
                            onChange={val => {
                                onChange({
                                    ...data,
                                    country: val
                                })
                            }}
                            required={true}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            required={false}
                            help={help.mail}
                            invalid={Boolean(help.mail)}
                            value={data.mail}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                mail: val
                            })}
                            label={"Email"}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            required={false}
                            help={help.phone}
                            invalid={Boolean(help.phone)}
                            value={data.phone}
                            onBlur={() => onBlur()}
                            onChange={val => onChange({
                                ...data,
                                phone: val
                            })}
                            label={"Telefon"}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>
})

export {
    FmsReceiverForm
}
